{
  "header": {
    "nameShowStaticText": false,
    "nameVariable": {
      "id": "6fea6d8d-7d9b-4b13-9779-d38d3ea23b43",
      "modelUri": "http://opcfoundation.org/UA/Mining/General/",
      "nodeId": "ns=1;i=6034",
      "displayName": "AssetId",
      "variablePath": "MiningEquipmentIdentification.AssetId",
      "dataType": "String",
      "valueRank": -1,
      "modellingRule": "Mandatory",
      "hasProperties": false
    },
    "modelShowStaticText": false,
    "modelVariable": {
      "id": "eb06b192-5019-48f9-ab22-7f63b7417565",
      "modelUri": "http://opcfoundation.org/UA/Mining/General/",
      "nodeId": "ns=1;i=6030",
      "displayName": "Model",
      "variablePath": "MiningEquipmentIdentification.Model",
      "dataType": "LocalizedText",
      "valueRank": -1,
      "modellingRule": "Mandatory",
      "hasProperties": false
    }
  },
  "imagesConfig": {
    "imageDefaults": {
      "[\\s\\S]*": "machine.jpg"
    }
  },
  "sections": [
    {
      "isPlaceholder": false,
      "title": "Identification",
      "rows": [
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Manufacturer",
              "showAsLink": false,
              "valueVariable": {
                "id": "7b3a1048-1a3d-438b-ad05-c75b1d43e242",
                "modelUri": "http://opcfoundation.org/UA/Mining/General/",
                "nodeId": "ns=1;i=6020",
                "displayName": "Manufacturer",
                "variablePath": "MiningEquipmentIdentification.Manufacturer",
                "dataType": "LocalizedText",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "ProductInstanceUri",
              "showAsLink": false,
              "valueVariable": {
                "id": "a5241731-f76f-41ed-a70d-22a89789d596",
                "modelUri": "http://opcfoundation.org/UA/Mining/General/",
                "nodeId": "ns=1;i=6031",
                "displayName": "ProductInstanceUri",
                "variablePath": "MiningEquipmentIdentification.ProductInstanceUri",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            },
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "Serial Number",
              "showAsLink": false,
              "valueVariable": {
                "id": "7a7ac676-c39d-41b2-9a5d-1702da8feb88",
                "modelUri": "http://opcfoundation.org/UA/Mining/General/",
                "nodeId": "ns=1;i=6033",
                "displayName": "SerialNumber",
                "variablePath": "MiningEquipmentIdentification.SerialNumber",
                "dataType": "String",
                "valueRank": -1,
                "modellingRule": "Mandatory",
                "hasProperties": false
              }
            }
          ]
        }
      ]
    },
    {
      "isPlaceholder": false,
      "title": "Parameter",
      "rows": [
        {
          "isPlaceholder": false,
          "elements": [
            {
              "type": 0,
              "isPlaceholder": false,
              "label": "",
              "showAsLink": false,
              "valueVariable": {
                "id": "252c97bd-40e5-45c9-a92d-809f0a0517a0",
                "modelUri": "http://opcfoundation.org/UA/Mining/TransportDumping/General/",
                "nodeId": "ns=1;i=6001",
                "displayName": "CurrentPayload",
                "variablePath": "ParameterSet.CurrentPayload",
                "dataType": "Double",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": true,
                "hasUnit": true,
                "hasRange": true
              }
            },
            {
              "type": 1,
              "isPlaceholder": false,
              "valueVariable": {
                "id": "252c97bd-40e5-45c9-a92d-809f0a0517a0",
                "modelUri": "http://opcfoundation.org/UA/Mining/TransportDumping/General/",
                "nodeId": "ns=1;i=6001",
                "displayName": "CurrentPayload",
                "variablePath": "ParameterSet.CurrentPayload",
                "dataType": "Double",
                "valueRank": -1,
                "modellingRule": "Optional",
                "hasProperties": true,
                "hasUnit": true,
                "hasRange": true
              },
              "customRangeHigh": 0,
              "customRangeLow": 5
            }
          ],
          "title": "CurrentPayload"
        }
      ]
    }
  ]
}
